import { AfterViewInit, Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
import { EbsWebServiceGlobals } from '../../services/ebsWebServiceGlobals';

@Component({
  selector: 'scanner-component',
  templateUrl: 'scanner.html',
  inputs: ['articleData']
})
export class ScannerComponent implements AfterViewInit {

  articleData: any;
  colorDesign: string = "";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public _ebsComponentService: EbsComponentService,
    public _ebsWebService: EbsWebService,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals) {
    this.colorDesign = this._ebsWebServiceGlobals.getColorDesign();
  }

  ngAfterViewInit(): void {

  }

  openPage() {
    if (typeof this.articleData.actionUrl != "undefined" && this.articleData.actionUrl != "" && this.articleData.actionUrl != null) {
      let navParams = { title: this.articleData.name, actionURL: this.articleData.actionUrl, postParams: this.articleData.actionParams };
      this._ebsComponentService.navigationController(this.articleData, navParams, this.navCtrl);
    } else {
      return;
    }
  }




}



// WEBPACK FOOTER //
// ./src/components/scanner/scanner.ts